import { CoveoAnalyticsClient } from 'coveo.analytics/modules';
import { GetCoveoConfig, GetCoveoToken } from 'Feature/Coveo/Helpers/CoveoApi';
import { useEffect } from 'react';
import { GetUserContext } from './CoveoSearchEngine';
import { useUserData } from 'Foundation/User/UserContext';
import { SitecoreFetch } from 'Api/api/SitecoreApi';
import { HttpStatusCodes, IServerResponse } from 'Utilities/ClientResponseUtility';

export function CoveoAnalytics() {
  const { userData } = useUserData();

  useEffect(() => {
    sendAnalytics();
  }, []);

  const sendAnalytics = async () => {
    try {
      const contentType = await GetContentType();
      const coveoToken = await GetCoveoToken();
      const coveoSiteConfig = await GetCoveoConfig();
      if (coveoSiteConfig && coveoToken) {
        const analyticsEndpoint = 'https://' + coveoSiteConfig.organizationId + '.analytics.org.coveo.com';
        const ua = new CoveoAnalyticsClient({ token: coveoToken, endpoint: analyticsEndpoint });
        ua.sendViewEvent({
          contentIdKey: '@clickableuri',
          contentIdValue: window.location.href,
          contentType: contentType,
          customData: GetUserContext(userData),
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const GetContentType = async () => {
    let contentType = '';
    try {
      let contentpath = document.querySelector('html')?.dataset.contentpath;
      if (contentpath) {
        let response = (await SitecoreFetch(
          `/api/sitecore/CoveoSearchAsync/GetContentTypeForPage?contentpath=${contentpath}`,
        )) as IServerResponse;
        if (response.Status.Code === HttpStatusCodes.OK) {
          contentType = response.Data;
        }
      }
    } catch (err) {
      console.error(err);
    }
    return contentType;
  };

  return <></>;
}
